export enum CompensationsEvents {
  showInfoAboutAddCompensation = 'show_info_about_add_compensation',
  closeInfoAboutAddCompensation = 'close_info_about_add_compensation',
}
